import React, { Children } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { colors } from '../../theme/index.js';
import fonts from '../../theme/fonts.js';
import { useTheme } from '@mui/system';
const signatureStyle = {
  fontFamily: 'AntaraDistance',
  fontWeight: 'bold',
  fontSize: 20
};
const StyledTextField = styled(TextField)(({
  theme
}) => ({
  '& .MuiInputBase-root': {
    fontFamily: '"AvenirLTPro-Book", sans-serif',
    fontWeight: 400,
    color: theme.palette.default.contrastText,
    // this keeps letter spacing consistent with site before mui5 upgrade
    letterSpacing: "0.14994px"
  },
  // this sets the border of the underlined variant to the right color when hovered
  "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
    borderColor: theme.palette.custom.textFieldHover,
    borderBottomWidth: "2px"
  },
  "& .MuiSelect-select-MuiInputBase-input-MuiInput-input:focus": {
    // borderColor: theme.palette.custom.textFieldHover,
    backgroundColor: "transparent"
  }
}));

/**
 *
 * @param {*} props
 */
const TextInput = ({
  id,
  testid,
  select,
  autoFocus,
  autoComplete = "off",
  error,
  placeholder,
  label,
  value,
  defaultValue,
  margin,
  onChange,
  onBlur,
  fullWidth,
  helperText,
  secure,
  inputProps,
  required,
  variant,
  disabled,
  multiline,
  backgroundColor,
  onKeyPress,
  rowsMax,
  rows,
  selectProps,
  selectOptions,
  customInputStyle,
  customStyle,
  customHelperTextProps,
  isSignature = false
}) => {
  const theme = useTheme();
  // If the data passed is an array, assign key value pairs. Otherwise use the object
  const wasArray = {
    ...selectOptions
  };
  const newObject = Object.keys(wasArray).map(key => ({
    key: wasArray[key],
    value: wasArray[key]
  }));
  let data = selectOptions && selectOptions.some(option => option.key) ? selectOptions : newObject;

  /**
   *
   */
  const _onChangeWithStop = event => {
    // only do this if we have a label
    if (label) {
      if (!select && event.target.value && ['name', 'first name', 'last name'].includes(label.toLowerCase())) {
        const name = event.target.value;
        event.target.value = name.charAt(0).toUpperCase() + name.slice(1);
      }
    }
    onChange(event);
  };
  return /*#__PURE__*/React.createElement(StyledTextField, {
    multiline: multiline,
    rowsmax: rowsMax,
    rows: rows,
    id: id || testid,
    select: select,
    autoFocus: autoFocus,
    error: Boolean(error),
    placeholder: placeholder,
    label: label,
    value: value,
    defaultValue: defaultValue,
    margin: margin || 'normal' // none, dense, or normal
    ,
    onChange: e => _onChangeWithStop(e),
    onKeyPress: onKeyPress,
    onBlur: onBlur,
    fullWidth: fullWidth,
    FormHelperTextProps: {
      style: {
        fontFamily: fonts.type.base,
        ...customHelperTextProps
      }
    },
    helperText: helperText || error,
    type: secure ? 'password' : 'text',
    InputProps: {
      autoComplete: autoComplete,
      style: {
        ...(isSignature ? signatureStyle : {})
      },
      ...inputProps
    },
    InputLabelProps: {
      style: {
        color: Boolean(!value) && disabled ? colors.mainTextGrey : theme.primary,
        fontFamily: fonts.type.light
      }
    },
    sx: {
      backgroundColor: disabled ? '#f7f7f7' : backgroundColor || null,
      letterSpacing: "0.14994px",
      "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: colors.mainTextGrey
      },
      // this changes the focus (ie when you click on an option from the select meni, the menu collapses and the value is highlighted) from a gray background to transparent
      "& .MuiInputBase-input:focus": {
        backgroundColor: "transparent"
      },
      // this sets the outline of the border when hovered
      '& .MuiOutlinedInput-root': {
        "&:hover fieldset": {
          // sets the border color of the outlined variant only if not disabled and no error present
          borderColor: !error && !disabled && theme.palette.custom.textFieldHover
        }
      },
      ...(isSignature && {
        '& .MuiOutlinedInput-notchedOutline': {
          fontSize: 25,
          marginBottom: '2px'
        }
      }),
      ...customStyle
    },
    required: required,
    variant: variant || "outlined",
    disabled: disabled,
    SelectProps: {
      // menu props set the popover menu location
      MenuProps: {
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        // this prop sets the color of the selected option when the select menu is used
        sx: {
          "&& .Mui-selected": {
            background: "#EBEBEB"
          },
          // this prop sets color of selected option for date picker (One more level down)
          "&&& .Mui-selected": {
            background: "#EBEBEB"
          },
          // this prop sets the HOVER color of the selected option when the select menu is used
          "&& .Mui-selected:hover": {
            background: "#EBEBEB"
          }
        },
        PaperProps: {
          sx: {
            borderRadius: "8px"
          }
        }
      },
      defaultValue: defaultValue
    }
  }, select && data.map(option => /*#__PURE__*/React.createElement(MenuItem, {
    key: option.key,
    value: option.value
  }, option.value)));
};
export default TextInput;